import AllInclusiveIcon from '@material-ui/icons/AllInclusive'
import GroupIcon from '@material-ui/icons/Group'
import HourglassEmptyOutlinedIcon from '@material-ui/icons/HourglassEmptyOutlined'
import LockOpenIcon from '@material-ui/icons/LockOpen'
import OndemandVideoIcon from '@material-ui/icons/OndemandVideo'
import PaymentIcon from '@material-ui/icons/Payment'
import PlayIcon from '@material-ui/icons/PlayCircleOutlineOutlined'
import SpeedIcon from '@material-ui/icons/Speed'
import {
  __,
  add,
  always,
  concat,
  lt,
  map,
  pathOr,
  pipe,
  propOr,
  reduce,
} from 'ramda'
import SchoolIcon from '@material-ui/icons/School'
import dateParser from '../../../../utils/date-time'

const courseDetails = {
  private: [],
  group: [
    {
      id: 'live',
      text: always(`Learn over live video calls`),
      icon: <OndemandVideoIcon />,
      condition: always(true),
    },
    {
      id: 'group',
      text: always(`Learn in a skill based group of students.`),
      icon: <GroupIcon />,
      condition: always(true),
    },
    {
      id: 'classes',
      text: pipe(propOr(0, 'classCount'), String, concat(__, ` classes.`)),
      icon: <SchoolIcon />,
      condition: always(true),
    },
    {
      id: 'duration',
      text: always(`Pick your batch`),
      icon: <HourglassEmptyOutlinedIcon />,
      condition: always(true),
    },
    {
      id: 'payment-modes',
      text: always(`Multiple payment options`),
      icon: <PaymentIcon />,
      condition: always(true),
    },
  ],
  recorded: [
    {
      id: 'availability',
      text: ({ startTime }) =>
        `Available from ${dateParser.dateMed(startTime)}`,
      icon: <LockOpenIcon />,
      condition: pipe(propOr(0, 'startTime'), lt(Date.now())),
    },
    {
      id: 'count',
      text: pipe(
        propOr({}, 'chapters'),
        map(pathOr([], ['lessons', 'length'])),
        reduce(add, 0),
        String,
        concat(__, ` video lessons with included resources`),
      ),
      icon: <PlayIcon />,
      condition: always(true),
    },
    {
      id: 'pace',
      text: () => `Self Paced Course, Learn whenever wherever.`,
      icon: <SpeedIcon />,
      condition: always(true),
    },
    {
      id: 'access',
      text: () => `Get lifetime access with one time purchase.`,
      icon: <AllInclusiveIcon />,
      condition: always(true),
    },
  ],
}

export default courseDetails
